import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from "@angular/core";
import { ActivatedRoute, Data, Router } from "@angular/router";
import { defaultDisplayTags } from "@vp/models";
import { AuthenticationService } from "@vp/shared/authentication";
import { UiDisplayTagService } from "@vp/shared/store/ui";
import { activatedRouteData } from "@vp/shared/utilities";
import { Subject } from "rxjs";
import { Observable } from "rxjs/internal/Observable";
import { map, takeUntil, tap } from "rxjs/operators";

@Component({
  selector: "vp-top-nav-search",
  standalone: false,
  templateUrl: "./top-nav-search.component.html",
  styleUrls: ["./top-nav-search.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TopNavSearchComponent implements OnInit, OnDestroy {
  @Input() showButtonText = true;
  quickSearchTag$: Observable<keyof typeof defaultDisplayTags> | undefined;
  inputOriginal = "";
  input = "";
  focused = false;

  @ViewChild("searchinput", { static: false }) searchinput!: ElementRef;

  private searchRoute!: string[];

  constructor(
    public uiDisplayTagService: UiDisplayTagService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public readonly authenticationService: AuthenticationService
  ) {}
  private readonly destroyed$ = new Subject<void>();

  ngOnInit(): void {
    this.quickSearchTag$ = this.router.events.pipe(
      activatedRouteData(this.activatedRoute),
      tap((data: Data) => {
        this.searchRoute = data.searchRoute ? [data.searchRoute] : [];
      }),
      map((data: Data) => data.quickSearchTag as keyof typeof defaultDisplayTags)
    );

    this.activatedRoute.queryParamMap.pipe(takeUntil(this.destroyed$)).subscribe({
      next: queryParamMap => {
        this.inputOriginal = queryParamMap.get("search") ?? "";
        this.input = queryParamMap.get("search") ?? "";
      }
    });
  }

  isSearching(): boolean {
    return this.input.length > 0;
  }

  checkIfEmpty(event: KeyboardEvent) {
    if (event.defaultPrevented) {
      return;
    }

    let handled = false;
    if (event.key !== undefined) {
      handled = true;
    } else if (event.keyCode !== undefined) {
      handled = true;
    }

    if (handled && this.input.length > 0 && event.code === "Delete") {
      this.clear();
    }

    if (handled) {
      event.preventDefault();
    }
  }

  SearchNow() {
    if (this.input !== "") {
      this.redirect(this.input);
    } else {
      this.clear();
    }
  }

  clear() {
    this.input = "";
    this.focused = true;
    this.redirect(this.input);
  }

  private redirect(searchString: string) {
    this.router.navigate(this.searchRoute, {
      queryParams: {
        search: searchString
      },
      queryParamsHandling: "merge"
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
